import { render, staticRenderFns } from "./InternationalOrdersOnHold.vue?vue&type=template&id=733d0182"
import script from "./InternationalOrdersOnHold.vue?vue&type=script&lang=js"
export * from "./InternationalOrdersOnHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports